import React from "react";
import { Row, Col, Modal, Button } from "antd";
import { useProjectState } from "../../../context/stateContext";
import OrdersInfoModalMap from "./OrdersInfoModalMap";
import OrderInfoModalContent from "./OrderInfoModalContent";
import "./index.css";

const OrdersInfoModal = ({ record }) => {
  const { showOrderDetails, setShowOrderDetails } = useProjectState();

  const isValidLocation =
    record[0].geocoding?.closeBillLatitude !== undefined &&
    record[0].geocoding?.closeBillLongitude !== undefined &&
    record[0].geocoding?.orderLatitude &&
    record[0].geocoding?.orderLongitude;

  return (
    <Modal
      className="orders-drivers-info-modal"
      centered
      width={isValidLocation ? "1300px" : "650px"}
      cancelButtonProps={{ style: { display: "none" } }}
      open={showOrderDetails}
      bodyStyle={{ height: "auto" }}
      footer={
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            onClick={() => setShowOrderDetails(!showOrderDetails)}
          >
            Затвори
          </Button>
        </div>
      }
      onCancel={() => setShowOrderDetails(!showOrderDetails)}
    >
      <Row>
        <Col xs={24} md={isValidLocation ? 12 : 24}>
          <OrderInfoModalContent record={record} />
        </Col>
        {isValidLocation && (
          <Col xs={24} md={12}>
            <OrdersInfoModalMap record={record} />
          </Col>
        )}
      </Row>
    </Modal>
  );
};

export default OrdersInfoModal;
